import React from 'react';
import Markdown from 'markdown-to-jsx';
import Section from './Section';
import Container from './Container';
import style from '../cssmodules/shareDetails.module.scss';

function ShareDetails({ shareDetails, modifyer }) {
  return (
    <Section modifyer={modifyer}>
      <Container>
        <div className={style.shareDetails}>
          <Markdown className={style.column}>{shareDetails.leftcol}</Markdown>
          <Markdown className={style.columnTwoThirds}>
            {shareDetails.rightcol}
          </Markdown>
        </div>
      </Container>
    </Section>
  );
}

ShareDetails.defaultProps = {
  modifyer: false,
};

export default ShareDetails;
